import React, { useState, useEffect } from 'react';
import { BaseCard } from '../UI/BaseCard';
import { BaseSelect } from '../UI/BaseSelect';
import { BaseButton } from '../UI/BaseButton';
import { __, sprintf } from '@wordpress/i18n';

import { useForm } from '../../hooks/useForm';
import { maxValueValidator, minValueValidator, numbersValidator, requiredFieldValidator } from '../../utils/validation';

export const CalculatorCatAge = () => {
  const [result, setResult] = useState(null);

  const mapper = [15, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 97];

  const petAges = {
    kitten: {
      article: __('a kitten', 'cooperpetcare'),
      plain: __('kitten', 'cooperpetcare')
    },
    adult: {
      article: __('an adult', 'cooperpetcare'),
      plain: __('adult', 'cooperpetcare')
    },
    senior: {
      article: __('a senior', 'cooperpetcare'),
      plain: __('senior', 'cooperpetcare')
    }
  };

  const { formValue, formErrors, setFormFieldValue, onFormSubmit } = useForm({
    form: {
      age: ''
    },
    rules: {
      age: [maxValueValidator(20), minValueValidator(0), numbersValidator(), requiredFieldValidator()]
    },
    onSubmit: () => {
      getCalculatorResult(formValue);
    }
  });

  useEffect(() => {
    setResult(null);
  }, [formValue]);

  const calculateCatType = (age) => {
    if (Number(age) === 1) return 'kitten';
    if (Number(age) >= 11) return 'senior';
    return 'adult';
  };

  const getCalculatorResult = ({ age }) => {
    const catType = calculateCatType(age);
    const humanAge = mapper[age - 1];

    setResult({ catType, humanAge });
  };

  const catAges = [...Array.from({ length: 20 }).map((_value, index) => ({ value: index + 1, text: `${index + 1}` }))];

  return (
    <div className="calculator calculator--age">
      <BaseCard title={__('Cat Age Calculator', 'cooperpetcare')}>
        <BaseSelect
          className="field persistent-placeholder"
          label={__('Age of cat', 'cooperpetcare')}
          placeholder={__('Please enter the age of your cat in years', 'cooperpetcare')}
          persistentPlaceholder={true}
          filterDisabled={true}
          isInvalid={!!formErrors.age}
          hint={formErrors.age}
          value={formValue.age}
          options={catAges}
          onSelect={setFormFieldValue('age')}
        ></BaseSelect>

        <BaseButton className="btn-rounded" variant="warning" onClick={onFormSubmit}>
          {__('Calculate', 'cooperpetcare')}
        </BaseButton>

        {result && (
          <div className={`result cat result--${result.catType}`}>
            <h3 className="result-title">{sprintf(__('Your pet is %s', 'cooperpetcare'), petAges[result.catType].plain)}</h3>
            <div
              className="result-description"
              dangerouslySetInnerHTML={{
                __html: sprintf(
                  __('In human years your cat is <b>%1s</b> years old and is considered %2s.', 'cooperpetcare'),
                  result.humanAge,
                  petAges[result.catType].article
                )
              }}
            />
          </div>
        )}
      </BaseCard>
    </div>
  );
};
